export default "__VITE_ASSET__COoWVYYA__"